import React from "react";
import "../../css/components/controls/HrnbLink.css";

export default function HrnbLink({ children, to, icon, as = "a", className = "", ...props }) {
    const Tag = as === "link" ? "a" : as; // если указан "link", заменяем на "a"

    return (
        <Tag
            href={to}
            className={`hrnb-link ${className}`}
            {...props}
        >
            {icon && <span className="hrnb-link__icon">{icon}</span>}
            {children && <span className="hrnb-link__text">{children}</span>}
        </Tag>
    );
};
